var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.64 15.632V5.333H.219v10.299zM1.93 3.927c1.193 0 1.936-.791 1.936-1.78C3.844 1.138 3.123.369 1.952.369s-1.936.77-1.936 1.78c0 .988.742 1.78 1.891 1.78zm3.605 11.705s.045-9.333 0-10.299h3.423v1.494h-.022c.45-.703 1.26-1.736 3.107-1.736 2.253 0 3.941 1.472 3.941 4.636v5.905h-3.422v-5.51c0-1.384-.496-2.329-1.735-2.329-.945 0-1.509.637-1.756 1.253-.09.219-.113.527-.113.834v5.752z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgLinkedin;